module.exports = __webpack_public_path__ + "img/emoji_wbqj.e0317bd4.png";